import { Validators } from "@angular/forms";
import {
  HardFormFieldTypeEnum,
  HardTableColumnTypeEnum,
  IHardFormField,
  IHardFormFieldParams,
} from "@hardcode-kz/ui";
import { ResourceManagementEndpoints } from "@app/shared/data-access/src/lib/resource-management/types/resource-management-endpoints";
import {
  IBaseConfig,
  IFormFieldFilter,
  ITable,
} from "@models/form/base-config";
import { LangEnum } from "@models/interface-management/localization";
import { TranslationFieldPartialValidator } from "@static/fields/fields-constant";
import { IRequestPriority } from "@app/shared/data-access/src/lib/resource-management/models/request-priority";

export class RequestPriorityConfig implements IBaseConfig {
  version = 1;
  dicType = ResourceManagementEndpoints.RequestPriority;
  isCrudByModal = true;
  hideAddBtn = true;
  updateMethod: "POST" | "PUT" | "PATCH" = "PATCH";

  fields: IHardFormField[] = [
    {
      name: "name",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.name",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      name: "description",
      params: {
        direction: "row",
        fields: TranslationFieldPartialValidator(
          "dicTable.description",
          HardFormFieldTypeEnum.Input,
          [LangEnum.RU, LangEnum.KZ, LangEnum.EN],
        ),
      },
    },
    {
      name: "code",
      title: "dicTable.code",
      type: HardFormFieldTypeEnum.Input,
      params: {
        readonly: true,
        validators: [Validators.required],
      },
    },
    {
      name: "sortOrder",
      title: "dicTable.sortOrder",
      type: HardFormFieldTypeEnum.Number,
      params: {
        validators: [Validators.required],
      },
    },
    {
      name: "color",
      title: "dicTable.color",
      type: HardFormFieldTypeEnum.ColorPicker,
      params: {
        validators: [Validators.required],
      },
    },
  ];

  filterTemplateColumns = "1fr";

  filterFields: IFormFieldFilter<IHardFormFieldParams>[] = [
    {
      name: "searchTerm",
      type: HardFormFieldTypeEnum.Input,
      placeholder: "base.search",
      outside: true,
    },
  ];

  tableConfig: ITable<IRequestPriority[]> = {
    showDefaultActions: true,
    hideDeleteBtn: true,
    tableColumns: "44px repeat(4,auto)",
    columns: [
      {
        title: "№",
        name: "index",
        type: HardTableColumnTypeEnum.Index,
      },
      {
        title: "dicTable.name",
        name: "name",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "dicTable.description",
        name: "description",
        type: HardTableColumnTypeEnum.Translate,
      },
      {
        title: "dicTable.color",
        name: "color",
        type: HardTableColumnTypeEnum.Color,
      },
    ],
  };
}
